import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchPagedStaffList} from 'api/profile';
import {createListModel} from 'core/hooks/list';
import {rootDomain} from 'core/rootDomain';
import {StaffAccessors, StaffListRawRow} from 'types/profile';

const domain = rootDomain.createDomain('StaffListDomain');

export const Gate = createGate('StaffListGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchPagedStaffList,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    sorting$,
    sortingChanged,
} = createListModel({domain, defaultSorting: [{id: StaffAccessors.id, desc: true}]});

interface StaffListContent {
    content: StaffListRawRow[];
    total: number;
}

export const data$ = domain.createStore<StaffListContent | null>(null);

export const listState$ = combine({
    data: data$,
    filters: filters$,
    sorting: sorting$,
    pageIncremented,
    isLoading: fetchDataFx.pending,
});
